/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type CustomerSubscriptionsTableV2SubscriptionFragment = { __typename: 'WaveSubscription', id: string, name: string, userGivenName?: string | null, validUntil: any, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null }, customers: Array<{ __typename: 'PartialCustomer', name: string }> };

export const CustomerSubscriptionsTableV2SubscriptionFragmentDoc = gql`
    fragment CustomerSubscriptionsTableV2Subscription on WaveSubscription {
  id
  name
  userGivenName
  usage {
    current
    max
  }
  validUntil
  customers {
    name
  }
}
    `;